<template lang="pug">
.deviceModalInfo
  //- .padding-double
  //-   img(src="@/assets/img/webserver.png")
  .van-cell-group__title {{ $t('new.unit.webserInfo') }}

  van-cell-group.no-margin-top
    //- van-cell(
    //-   v-if="device.manufacturer"
    //-   :title="$t('unit.manufacturer')"
    //-   :value="device.manufacturer")
    van-cell(
      :title="$t('new.unit.mac')"
      :value="mac")
    van-cell.version(
      :title="$t('unit.firmDKN')"
      :value="version")
    van-cell.tai(
      v-if="device.acs_available"
      :title="$t('unit.modeAvailable')"
      :value="modeTaiTh")
    van-cell.operatingMode(
      v-if="!device.isS21 && operatingMode"
      :title="$t('unit.operatingMode')"
      :value="operatingMode")
    van-cell(
      :title="$t('unit.control')"
      :value="controlMode")
    van-cell.wifi(
      :title="$t('new.unit.wifi')")
      template(slot="right-icon" v-if="device.isConnected")
        span.van-cell-text {{ device.stat_ssid }} ({{ device.stat_channel }})
        Coverage.margin-quarter-left.no-margin-right(:signal="device.stat_rssi")

  .deviceModalInfo__pro(v-if="airtools")
    .van-cell-group__title Unidad Interior Airtools

    van-cell-group.no-margin-top
      van-cell(
        v-if="device.local_temp"
        title="Tª Consigna"
        :value="parseTemp(device.local_temp)")
      van-cell(
        v-if="device.work_temp"
        title="Tª Returno"
        :value="parseTemp(device.work_temp)")
      van-cell(
        v-if="device.mode"
        title="Modo de trabajo"
        :value="modeTitle(device.mode)")
      van-cell(
        v-if="device.speed_state"
        title="Velocidad ventilador"
        :label="`DISPONIBLES: ${device.speed_available}`"
        :value="device.speed_state")
      van-cell(
        v-if="device.exch_heat_temp_iu"
        title="Tª intercambiador"
        :value="parseTemp(device.exch_heat_temp_iu)")
      van-cell(
        v-if="device.gas_pipe_temp_iu"
        title="Tª tubería gas"
        :value="parseTemp(device.gas_pipe_temp_iu)")
      van-cell(
        v-if="device.exp_valv_ui"
        title="Pulso Válvula expansion"
        :value="device.exp_valv_ui")

    .van-cell-group__title Unidad Exterior Airtools

    van-cell-group.no-margin-top
      van-cell(
        v-if="device.consumption_ue || device.consumption_ue === 0"
        title="Consumo"
        :value="parseConsumption(device.consumption_ue)")
      van-cell(
        v-if="device.ext_temp"
        title="Temperatura exterior"
        :value="parseTemp(device.ext_temp)")
      van-cell(
        v-if="device.exch_heat_temp_ue"
        title="Tª intercambiador"
        :value="parseTemp(device.exch_heat_temp_ue)")
      van-cell(
        v-if="device.disch_comp_temp_ue"
        title="Tª descarga compresor"
        :value="parseTemp(device.disch_comp_temp_ue)")
      van-cell(
        v-if="device.exp_valv_ue"
        title="Pulso Válvula expansion"
        :value="device.exp_valv_ue")
      van-cell(
        v-if="device.pe_ue"
        title="Presión evaporación"
        :value="parsePressure(device.pe_ue)")
      van-cell(
        v-if="device.pc_ue"
        title="Presión condensación"
        :value="parsePressure(device.pc_ue)")
      van-cell(
        v-if="device.frec"
        title="Frecuencia compresor"
        value="----")

  div.unitError(v-if="machineError || device.tsensor_error")
    .van-cell-group__title {{ $t('new.unit.unitInfo') }}

    van-cell-group.no-margin-top
      van-cell.unitAlert(
        v-if="device.tsensor_error"
        :title="$t('unit.sensor')")
      van-cell(
        v-if="machineError"
        :title="$t('new.unit.machineError')"
        :value="errorCode")
      van-cell(
        v-if="machineError && !device.power && !device.power_acs"
        :title="$t('new.unit.machineOff')")
      van-cell(
        v-if="machineError && (device.power || device.power_acs)"
        :title="$t('new.unit.machineOn')"
        :value="$t('new.unit.turnoff')"
        @click="swithOff()"
        is-link)
      van-switch-cell(
        v-if="machineError && showEmergencyHeat"
        v-model="device.emerheatstatus",
        :title="$t('auxheat.emergencyheat')",
        @change='setEmergencyHeat'
      )

  .popup__button.popup__button--confirm(@click="$emit('close')")
    | {{ $t('unit.confirm') }}
</template>

<script>
import i18n from '@/locales/i18n';
import SocketService from '@/services/socket.service';
import DisableArcadeMixin from '@/mixins/DisableArcade.mixin';
import Coverage from '@/components/Coverage.vue';
import GetModeTitle from '@/mixins/GetModeTitle.mixin';
import { UnitFilter } from '@/filters/Temp.filter';
import { mapGetters } from 'vuex';
import { CONFIG } from '@/app.config';
import { hasProp } from '@/utils/validate.utils';

export default {
  components: { Coverage },
  mixins: [DisableArcadeMixin, GetModeTitle],
  filters: { UnitFilter },
  data() {
    return {
      airtools: CONFIG.AIRTOOLS,
    };
  },
  props: {
    mac: {
      type: String,
      required: true,
    },
    installationID: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      getDevice: 'unitsModule/getDevice',
    }),

    /**
     * Devuelve los datos del dispositivo almacenados en el Store
     *
     * @return {Device} - Datos del dispositivo
     */
    device() {
      return this.getDevice(this.installationID, this.mac);
    },

    machineError() {
      return this.device.error_value > 0;
    },
    errorCode() {
      return this.device.error_ascii2
        ? `${this.device.error_ascii1}${this.device.error_ascii2}`
        : this.device.error_ascii1;
    },
    version() {
      return this.device.version;
    },

    modeTaiTh() {
      return this.device.tai_th ? this.$i18n.t('unit.th') : this.$i18n.t('unit.tai');
    },

    operatingMode() {
      if (!hasProp(this.device, 'device_master_slave')) return null;

      return this.device.device_master_slave
        ? this.$i18n.t('unit.mainMode')
        : this.$i18n.t('unit.subMode');
    },

    controlMode() {
      if (this.device.link_fallback && !this.device.link_isConnected) {
        return this.$i18n.t('unit.controlFallback');
      }
      if (this.device.link_deviceID) {
        return this.$i18n.t('unit.controlThirdParty');
      }
      return this.$i18n.t('unit.controlDefault');
    },

    /**
     * Devuelve si muestra el calor de emergencia
     */
    showEmergencyHeat() {
      if (this.device.emerheatpresent && this.device.mode === 3) {
        return true;
      }

      return false;
    },
  },
  methods: {
    modeTitle() {
      return this.GetModeTitle(this.device.mode);
    },

    parseConsumption(value) {
      if (!value) return '-- A';
      return `${value} A`;
    },

    parseTemp(value) {
      const units = this.$options.filters.UnitFilter(this.device.units);
      if (!value) return `-- ${units}`;
      return `${value} ${units}`;
    },

    parsePressure(value) {
      if (!value) return '-- MPa';
      return `${value} MPa`;
    },

    swithOff() {
      this.setProperty('power', false);

      if (this.device.acs_available) {
        this.setProperty('power_acs', false);
      }
    },

    /**
     * Cambia el calor de emergencia
     *
     */
    setEmergencyHeat() {
      this.setProperty('emerheatstatus', this.device.emerheatstatus);
    },

    /**
     * Envía un evento con el nuevo valor de la propiedad
     *
     * @param {String} property - Propiedad que se quiere modificar
     * @param {String} value - Valor de la propiedad
     */
    setProperty(property, value) {
      try {
        const mac = this.mac;
        const data = { mac, property, value };
        SocketService.setDeviceValue(this.installationID, data);
      } catch (error) {
        this.$toast.fail({
          mask: true,
          message: i18n.t('general.errors.default.message'),
        });
      }
    },
  },
};
</script>

<style lang="scss">
.van-cell {
  &__title {
    flex: 2;
    overflow: hidden;
    text-overflow: initial;
    white-space: initial;
  }
}
</style>
